module.exports = __webpack_public_path__ + "img/STHander_Sword Two-Hander Yellow.7636c98c.png";